import { MdOutlineClear } from 'react-icons/md';
import { Button, Tab, Tabs } from '@ds';
import { FilterDropdown } from '@ui';
import { UseFiltersType } from '@/hooks/useFilters';
import { EmployeeListFilters, EmployeeRole, EmployeeStatus } from '@/api/apis/resources';
import { useSearchableList } from '@/hooks/useSearchableList';
import { useHubsSearchableList } from '@/hooks/useHubsSearchableList';
import { useTrialProgramsList } from '@/hooks/useTrialProgramsList';
import { EMPLOYEE_ROLES_SELECT_LIST, SHIFT_TIME_GROUPS_SELECT_LIST } from '../config';

type EmployeesFiltersProps = UseFiltersType<EmployeeListFilters>;

export const EmployeesFilters = ({ filters, hasFilters, updateFilters, clearFilters }: EmployeesFiltersProps) => {
  const filteredRolesList = EMPLOYEE_ROLES_SELECT_LIST.filter(
    (role) => role.value !== EmployeeRole.ContractorRetrievalSurgeon,
  );

  const { trialProgramsList } = useTrialProgramsList();
  const { list: rolesList, setSearchValue: onRoleSearch } = useSearchableList(filteredRolesList, ['name', 'value']);

  const {
    list: baseLocationList,
    isLoading,
    setSearchValue: onLocationSearch,
  } = useHubsSearchableList({ searchBy: ['name', 'code'] });

  return (
    <div className="flex gap-7 items-center">
      <FilterDropdown
        title="Role"
        items={rolesList}
        selectedKeys={filters.roles ?? []}
        mode="multiple"
        onSearchValue={onRoleSearch}
        onSelectedKeysChange={(values) => updateFilters(values, 'roles')}
      />
      <FilterDropdown
        title="Base location"
        items={baseLocationList}
        selectedKeys={filters.baseLocation ?? []}
        mode="multiple"
        isLoading={isLoading}
        onSearchValue={onLocationSearch}
        onSelectedKeysChange={(values) => updateFilters(values, 'baseLocation')}
      />
      <FilterDropdown
        title="Trial Programs"
        items={trialProgramsList}
        selectedKeys={filters.trialProgramIds}
        mode="multiple"
        onSelectedKeysChange={(values) => updateFilters(values, 'trialProgramIds')}
      />
      <FilterDropdown
        title="Shift Time Group"
        items={SHIFT_TIME_GROUPS_SELECT_LIST}
        selectedKeys={filters.shiftTimeGroup ?? []}
        mode="multiple"
        onSelectedKeysChange={(values) => updateFilters(values, 'shiftTimeGroup')}
      />
      <Tabs
        radius="full"
        aria-label="employee status filter"
        selectedKey={filters.status}
        onSelectionChange={(value) => updateFilters(value as EmployeeStatus, 'status')}
        classNames={{
          tabList: 'bg-base-50 p-0 gap-0',
          tabContent: 'px-2 text-s-sb group-data-[selected=true]:text-base-90',
          cursor: 'bg-base-5',
        }}
      >
        <Tab key={EmployeeStatus.All} title="All" />
        <Tab key={EmployeeStatus.Active} title="Active" />
        <Tab key={EmployeeStatus.Inactive} title="Inactive" />
      </Tabs>
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onClick={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
